import { Link } from 'react-router-dom';
import useIsMobile from '../../utils/hooks/useIsMobile';
import s from '../../styles/components/shows/NoShows.module.css';

export default function NoShows({ data, images }) {
  const isMobile = useIsMobile();

  return (
    <section className={isMobile ? s.containerMobile : s.container}>
      <div className={isMobile ? s.wallMobile : s.wall}>
        {images.map((tile) => (
          <img key={tile.id} src={tile.image} alt="" className={s.photo} />
        ))}
      </div>

      <div className={s.overlay} />

      <div className={s.content}>
        <span className={s.eyebrow}>{data.eyebrow}</span>
        <h1 className={isMobile ? s.headlineMobile : s.headline}>{data.headline}</h1>
        <p className={s.subhead}>{data.subhead}</p>
        <Link to={data.buttonUrl} className={s.btn}>
          {data.buttonLabel}
        </Link>
        <p className={s.blurb}>{data.blurb}</p>
      </div>
    </section>
  );
}